import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5367b92&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5367b92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5367b92')) {
      api.createRecord('c5367b92', component.options)
    } else {
      api.reload('c5367b92', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c5367b92&scoped=true&", function () {
      api.rerender('c5367b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/association/modules/table-list/index.vue"
export default component.exports